import { Code2, TrendingUp, Headphones, Calculator, Factory, Truck, Stethoscope, GraduationCap, Users, HardHat, Plane, Scale, Briefcase, ShoppingCart, Utensils, Car, Palette, Camera, Wrench, Scissors, Megaphone, Globe, Heart, Shield, Music, Dumbbell } from "lucide-react";

export const CATEGORY_ICONS = {
  Code2, TrendingUp, Headphones, Calculator, Factory, Truck,
  Stethoscope, GraduationCap, Users, HardHat, Plane, Scale, Briefcase,
  ShoppingCart, Utensils, Car, Palette, Camera, Wrench, Scissors,
  Megaphone, Globe, Heart, Shield, Music, Dumbbell,
};

export const WORK_TYPES = ["Tam Zamanlı", "Yarı Zamanlı", "Uzaktan", "Stajyer", "Vardiyalı", "Proje Bazlı"];

export const CITIES = [
  "Uzaktan",
  "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya", "Ardahan", "Artvin",
  "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl", "Bitlis", "Bolu", "Burdur",
  "Bursa", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır", "Düzce", "Edirne", "Elazığ", "Erzincan",
  "Erzurum", "Eskişehir", "Gaziantep", "Giresun", "Gümüşhane", "Hakkâri", "Hatay", "Iğdır", "Isparta", "İstanbul",
  "İzmir", "Kahramanmaraş", "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kilis", "Kırıkkale", "Kırklareli",
  "Kırşehir", "Kocaeli", "Konya", "Kütahya", "Malatya", "Manisa", "Mardin", "Mersin", "Muğla", "Muş",
  "Nevşehir", "Niğde", "Ordu", "Osmaniye", "Rize", "Sakarya", "Samsun", "Siirt", "Sinop", "Sivas",
  "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat", "Trabzon", "Tunceli", "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak",
];
